import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { getSeaLinkBasename } from 'utils/helpers';

const SubNavigationBar = () => {
  const metaFlow = useSelector((state) => state.ui.sealink.metaFlow);
  const fullScreen = metaFlow.currentStep?.match(/^\/bookings\/accommodation/);

  let secondBreadcrumb = null;

  if (/^\/bookings\/accommodation/.test(metaFlow.currentStep)) {
    secondBreadcrumb = <li className="breadcrumb-item">Book accommodation</li>;
  } else if (metaFlow.currentStep === '/') {
    secondBreadcrumb = null;
  } else {
    secondBreadcrumb = <li className="breadcrumb-item">Book a ferry</li>;
  }

  return (
    <div className="d-lg-none">
      <nav className="breadcrumb-wrapper">
        <ol className={`breadcrumb ${fullScreen ? 'mb-0' : ''}`}>
          <li className="breadcrumb-item">
            <a href={`/${getSeaLinkBasename()}/`}>
              <i className="far fa-house" />
            </a>
          </li>
          <li
            className={classNames([
              'breadcrumb-item',
              { active: secondBreadcrumb },
            ])}
          >
            <Link to="/bookings">Book your trip</Link>
          </li>
          {secondBreadcrumb}
        </ol>
      </nav>
    </div>
  );
};

export default SubNavigationBar;
